/**
 * Parcelamento — mantém o texto de parcelas e o preço à vista no Pix
 * sincronizados com a variação selecionada na página do produto.
 *
 * O bloco é renderizado pelo snippet `installments.liquid`, que já entrega o
 * texto correto no primeiro carregamento. Este script só recalcula quando o
 * cliente troca de variação.
 */
(function () {
  'use strict';

  var STRINGS = window.themeInstallmentsStrings || {};

  function moneyFormat(cents) {
    var value = (cents / 100).toFixed(2).replace('.', ',');
    var parts = value.split(',');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return 'R$ ' + parts.join(',');
  }

  function bestInstallments(priceCents, max, minValueCents) {
    var best = 1;
    for (var i = 1; i <= max; i++) {
      if (Math.floor(priceCents / i) >= minValueCents) best = i;
    }
    return best;
  }

  // Os tokens vêm no formato ||nome||, definidos em layout/theme.liquid.
  function interpolate(template, values) {
    return String(template || '').replace(/\|\|(\w+)\|\|/g, function (match, key) {
      return Object.prototype.hasOwnProperty.call(values, key) ? values[key] : match;
    });
  }

  function update(root, priceCents) {
    if (!priceCents || priceCents <= 0) return;

    var max = parseInt(root.dataset.max, 10) || 12;
    var minValue = parseInt(root.dataset.minValue, 10) || 0;
    var interestFree = root.dataset.interestFree === 'true';
    var pixPercent = parseInt(root.dataset.pixPercent, 10) || 0;

    var count = bestInstallments(priceCents, max, minValue);
    var per = Math.ceil(priceCents / count);

    var line = root.querySelector('[data-installments-line]');
    if (line) {
      if (count > 1) {
        var template = interestFree
          ? STRINGS.up_to_installments_html
          : STRINGS.in_installments_with_interest_html;
        line.innerHTML = interpolate(template, {
          count: count,
          amount: moneyFormat(per),
        });
      } else {
        line.textContent = '';
      }
    }

    var pix = root.querySelector('[data-installments-pix]');
    if (pix) {
      var pixPrice = Math.round((priceCents * (100 - pixPercent)) / 100);
      pix.innerHTML =
        pixPercent > 0
          ? interpolate(STRINGS.cash_discount_html, {
              amount: moneyFormat(pixPrice),
              percent: pixPercent + '%',
            })
          : interpolate(STRINGS.cash_price_html, { amount: moneyFormat(pixPrice) });
    }

    root.dataset.price = String(priceCents);
  }

  function currentVariantId(root) {
    var scope =
      root.closest('[data-section-id]') ||
      root.closest('.shopify-section') ||
      document;
    var input = scope.querySelector('[name="id"]');
    return input ? parseInt(input.value, 10) : null;
  }

  function syncFromVariant(root) {
    var raw = root.getAttribute('data-variant-prices');
    if (!raw) return;

    var prices;
    try {
      prices = JSON.parse(raw);
    } catch (error) {
      return;
    }

    var id = currentVariantId(root);
    if (id && Object.prototype.hasOwnProperty.call(prices, String(id))) {
      update(root, prices[String(id)]);
    }
  }

  function observe(root) {
    if (root.dataset.installmentsBound === 'true') return;
    root.dataset.installmentsBound = 'true';

    if (!root.getAttribute('data-variant-prices')) return;

    var scope = root.closest('[data-section-id]') || root.closest('.shopify-section');
    if (!scope) return;

    // O tema reescreve o preço ao trocar de variação — usamos isso como gatilho.
    var priceWrapper = scope.querySelector('[data-price-wrapper]');
    if (priceWrapper) {
      new MutationObserver(function () {
        syncFromVariant(root);
      }).observe(priceWrapper, { childList: true, subtree: true, characterData: true });
    }

    scope.addEventListener('change', function (event) {
      if (event.target && event.target.name === 'id') syncFromVariant(root);
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-installments]').forEach(observe);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
